<!-- <dst-create-disclosure-actions [disabled]="false" (onSaveClick)="save()" (onCancelClick)="cancel()"></dst-create-disclosure-actions> -->
<!--<div id="overlay">-->
<!--  <ap-loading *ngIf="startLoader" id="text" class="loader-class" [colorName]="'a-primary'">-->
<!--  </ap-loading>-->
<!--</div>-->
@if (startLoader) {
  <div class="loader-overlay">
    <div class="backdrop"></div>
    <ap-loading class="loader" [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
  </div>
}
<dst-create-disclosure-actions [isView]="false" (onSaveClick)="save()" [disabled]="false" [displayNotification]="showDREMsg" [notifMsg]="DREMsg"
  (onCancelClick)="clear()">
</dst-create-disclosure-actions>
<div class="form-template-wrapper" [ngClass]="showDREMsg ? 'msg-expanded' : ''">
  <div [formGroup]="form184">
    <dst-template-header [parentFormGroup]="form184" [overwriteFormName]="'STATEMENT PURSUANT TO SECTION 1.351-3'"
      [allowOptional]="true" [dropDownOptions]="headerOptions" (formOptionChanged)="onFormOptionChanged($event)"
    (consolGroupChanged)="OnConsolGroupChanged($event)"></dst-template-header>
    <ol style="margin: 15px;">
      <li class="one-point-four">The following property was transferred from
        <dst-template-leid-selector #mainLeidSelector [label]="'Please specify the LEID of the Transferor'"
          [labelId]="'100'" (onSelectedLEChanged)="onTransferorChanged($event)" class="required-field entity-leid-label">
        </dst-template-leid-selector>
        <!-- <div class="a-form-error error-leid" *ngIf="transferor === undefined">
        Please specify the Transferor
      </div> -->
      <div class="entity-details">
        <span>Name of Transferor:</span><span class="template-color-blue">{{!transferor ? '' :
      transferor.ENTITY}}</span>
    </div>
    <div class="entity-details">
      <span>EIN:</span><span class="template-color-blue">{{!transferor ? '' : (transferor.EIN ? transferor.EIN : 'N/A')}}</span><span>, a
    Transferor</span>
  </div>
  <div class="entity-details">
    <span></span><span class="template-color-blue">{{!transferor ? '' : transferor.COUNTRYINC +
    (transferor | taxtype: transferor?.TAXTYPECODE: entityNameChangeOnDate)}}</span><span>&nbsp;to</span>
  </div>
  <dst-template-leid-selector [label]="'Please specify the LEID of the Transferee'" [labelId]="'101'"
    (onSelectedLEChanged)="onTransfereeChanged($event)" class="required-field entity-leid-label">
  </dst-template-leid-selector>
  <!-- <div class="a-form-error error-leid" *ngIf="transferee === undefined">
  Please specify the Transferee
</div> -->
<div class="entity-details">
  <span>Name of Transferee:</span><span class="template-color-blue">{{!transferee ? '' :
transferee.ENTITY}}</span>
</div>
<div class="entity-details">
  <span>EIN:</span><span class="template-color-blue">{{!transferee ? '' : (transferee.EIN ? transferee.EIN : 'N/A')}}</span><span>,&nbsp;a
Transferee</span>
</div>
<div class="entity-details">
  <span></span><span class="template-color-blue">{{!transferee ? '' : transferee.COUNTRYINC }}</span> &nbsp;<span>Corporation.</span>
  <!-- <span></span><span class="template-color-blue">{{!transferee ? '' : transferee.COUNTRYINC +
  (transferee | taxtype: transferee?.TAXTYPECODE: entityNameChangeOnDate)}}</span><span>.</span> -->
</div>
</li>
<li class="one-point-four">The date(s) of the transfer(s) of assets:
  <div formGroupName="datesTransfer">
    <input type="hidden" formControlName="tran1">
    <input type="hidden" formControlName="tran2">
    <app-date-picker-with-clear
      [minDate]="beginDate"
      [maxDate]="endDate"
      [datePickerClass]="'required-field'"
      [required]="true"
      (dateChange)="dateChange($event, 1)"
      (datePickerClick)="onDPOpen()"
      (clearClick)="clearDate(1)"
      [(ngModel)]="defaultDate"
      [ngModelOptions]="{standalone: true}">
    </app-date-picker-with-clear>
    <!-- *ngIf="nameChangeChecked"  removed from above-->
    <!-- <div class="a-form-error"
    *ngIf="defaultDate === null && liquidationDate2 === null && liquidationDate3 === null">
    Please specify the Transaction date
  </div> -->
  <app-date-picker-with-clear
    [minDate]="beginDate"
    [maxDate]="endDate"
    (dateChange)="dateChange($event, 2)"
    (datePickerClick)="onDPOpen()"
    (clearClick)="clearDate(2)"
    [(ngModel)]="liquidationDate2"
    [ngModelOptions]="{standalone: true}">
  </app-date-picker-with-clear>
  <app-date-picker-with-clear
    [minDate]="beginDate"
    [maxDate]="endDate"
    (dateChange)="dateChange($event, 3)"
    (datePickerClick)="onDPOpen()"
    (clearClick)="clearDate(3)"
    [(ngModel)]="liquidationDate3"
    [ngModelOptions]="{standalone: true}">
  </app-date-picker-with-clear>
</div>
</li>
<li><span class="one-point-four">Property Transferred:</span>
<div formGroupName="propertiesDetails">
  <p class="one-point-four">
    The fair market value and basis of the property transferred by such transferor in the exchange, determined
    immediately before the transfer and
    aggregated as follows:
  </p>
  <ol class="inner-list">
    <li>
      <div class="list-content a-textarea-box a-field-length-validation">
        <span class="Appkit4-icon icon-information-fill red-icon" ap-tooltip [tooltipContent]="template1" [direction]="'right'"
        [tooltipId]="'sec351-importation-prop-info'" ariaDescribedby="sec351-importation-prop-info"></span>
        <span class="Appkit4-icon icon-information-fill red-icon" ap-tooltip [tooltipContent]="template2" [direction]="'right'"
        [tooltipId]="'sec351-loss-import-info'" ariaDescribedby="sec351-loss-import-info"></span>
        <span class="a-form-label textarea-label" style="font-size: inherit;">Importation property transferred in a loss importation transaction, as defined in Sec. 1.362-3(c)(2) and (3), respectively;</span>
        <ap-field [fieldId]="'310'" [styleClass]="'text-box'">
                    <textarea appkit-field maxlength="1000" name="importationProp" [(ngModel)]="importationProp" [ngModelOptions]="{standalone: true}" aria-label="310"></textarea>
          <ap-field-counter [max]="1000" [value]="importationProp"></ap-field-counter>
        </ap-field>
        <!-- <print-error [control]="this.form184.get('propertiesDetails')?..get('importationProp')"></print-error> -->
      </div>
    </li>
    <li>
      <div class="list-content a-textarea-box a-field-length-validation">
        <span class="a-form-label textarea-label" style="font-size: inherit;">Loss duplication property as defined in Sec. 1.362-4(g)(1);</span>
        <ap-field [fieldId]="'320'" [styleClass]="'text-box'">
                    <textarea appkit-field maxlength="1000" [(ngModel)]="lossDupProp" [ngModelOptions]="{standalone: true}" aria-label="320"></textarea>
          <ap-field-counter [max]="1000" [value]="lossDupProp"></ap-field-counter>
        </ap-field>
      </div>
    </li>
    <li>
      <div class="list-content a-textarea-box a-field-length-validation">
        <span class="a-form-label textarea-label" style="font-size: inherit;">Property with respect to which any gain or loss was recognized on the transfer (without regard to whether such property is also identified in paragraph (a)(3)(i) or (ii) of this Section);</span>
        <ap-field [fieldId]="'330'" [styleClass]="'text-box'">
                    <textarea appkit-field maxlength="1000" [(ngModel)]="gainLossAffectedProp" [ngModelOptions]="{standalone: true}" aria-label="330"></textarea>
          <ap-field-counter [max]="1000" [value]="gainLossAffectedProp"></ap-field-counter>
        </ap-field>
      </div>
    </li>
    <li>
      <div class="list-content">
        <span class="a-form-label d-inline-block" style="cursor: default; font-size: inherit;">Property not described in paragraph (a)(3)(i), (ii), or (iii) of this Section;</span>

        <table class="table-layout properties-table">
          <tbody>
            <tr>
              <td colspan="3">
                @if (showImport) {
                  <ap-button [compact]="true" [btnType]="'primary'" [label]="'Import Domestic or Foreign Trial Balance Data'"
                    class="import-btn ap-mr-spacing-3" (onClick)="import()" [disabled]="!defaultDate">
                  </ap-button>
                }
                @if (showTotal) {
                  <ap-checkbox [styleClass]="'a-mx-10 import-btn'"
                    (onChange)="total($event)">
                    <span>Report TB Data on Total Net Assets basis</span>
                  </ap-checkbox>
                }
              </td>
              <td>
                <ap-dropdown [list]="propertyValBasisOptions[0]?.data || []" [selectType]="'single'" [showSearchbox]="true"
                  [title]="'** Select a basis **'" [inputAriaLabel]="'** Select a basis **'" (onSelect)="selectBasisOption($event)"
                  [optionName]="'text'"
                  [hideTitleOnInput]="true" [(ngModel)]="selectedBasisItem" [ngModelOptions]="{standalone: true}" class="a-dropdown show-label required-field-dropdown field-full-width">
                  @for (item of propertyValBasisOptions[0]?.data || []; track $index) {
                    <ap-dropdown-list-item #dropdownListItem [item]="item"
                      [ariaLabel]="setAriaLabel(item, '** Select a basis **')" [optionName]="'text'"
                    (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                  }
                </ap-dropdown>
                <!-- <div class="a-form-error" *ngIf="selectedBasis === -1">
                Please select a Basis section
              </div> -->
            </td>
            <td class="amount-column"></td>
          </tr>
          <tr>
            <td colspan="3"></td>
            <td><span class="thirteen">{{ selectedBasisName }} Basis to the Transferor</span></td>
            <td><span class="thirteen">Fair Market Value on Date of Transfer</span></td>
          </tr>
          <tr>
            <td colspan="2"></td>
            <td class="header-column"><span>Description</span></td>
            <td>
              <ap-dropdown [list]="currencyOptions[0]?.data || []" [selectType]="'single'" [showSearchbox]="true"
                [title]="'** Select Currency **'" [inputAriaLabel]="'** Select Currency **'" (onSelect)="currencyOneChange($event)"
                [optionName]="'text'"
                [hideTitleOnInput]="true" [(ngModel)]="selectedCurrencyItem" [ngModelOptions]="{standalone: true}" class="a-dropdown show-label required-field-dropdown currency-dropdown field-full-width">
                @for (item of currencyOptions[0]?.data || []; track $index) {
                  <ap-dropdown-list-item #dropdownListItem [item]="item"
                    [ariaLabel]="setAriaLabel(item, '** Select Currency **')" [optionName]="'text'"
                  (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                }
              </ap-dropdown>
              <!-- <div class="a-form-error" *ngIf="selectedCurrency === 0">
              Please select Fair Market value Currency type
            </div> -->
          </td>
          <td>
            <ap-dropdown [list]="currencyOptions2[0]?.data || []" [selectType]="'single'" [showSearchbox]="true"
              [title]="'** Select Currency **'" [inputAriaLabel]="'** Select Currency **'" (onSelect)="currencyTwoChange($event)"
              [optionName]="'text'"
              [hideTitleOnInput]="true" [(ngModel)]="selectedCurrencyItem2" [ngModelOptions]="{standalone: true}" class="a-dropdown show-label required-field-dropdown currency-dropdown field-full-width">
              @for (item of currencyOptions2[0]?.data || []; track $index) {
                <ap-dropdown-list-item #dropdownListItem [item]="item"
                  [ariaLabel]="setAriaLabel(item, '** Select Currency **')" [optionName]="'text'"
                (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
              }
            </ap-dropdown>
          </td>
        </tr>
        <ng-container formArrayName="additionalPropsDetails">
          @for (p of additionalPropsDetails.controls; track p; let i = $index) {
            <tr [formGroup]="$any(p)">
              <td style="width: 3%;">
                @if (i > 0) {
                  <ap-button [compact]="true" class="btn-plus-minus" [btnType]="'secondary'"
                    [icon]="'minus-outline'" [add]="true"
                    (onClick)="removeAdditionalPropDetailsAt(i)">
                  </ap-button>
                }
              </td>
              <td style="width: 3%;">
                <ap-button [compact]="true" class="btn-plus-minus" [btnType]="'secondary'"
                  [icon]="'plus-outline'" [add]="true"
                  (onClick)="addAdditionalPropDetails()">
                </ap-button>
              </td>
              <td style="width: 50%;">
                <ap-field [title]="''" [fieldId]="'prop-desc-' + i" [hideTitleOnInput]="true">
                  <input appkit-field formControlName="description" [attr.aria-label]="'Description ' + (i + 1)" />
                </ap-field>
              </td>
              <td style="width: 22%;">
                <ap-field [title]="''" [fieldId]="'prop-basis-' + i" [type]="'appkit-number'" [format]="''"
                  [styleClass]="'number-field'">
                  <input appkit-field onlyDigitsDecimal formControlName="transferorBasis" [attr.aria-label]="'Basis to the transferor ' + (i + 1)"
                    (input)="onChangeNumber({value: $any($event.target).value}, i)" />
                </ap-field>
              </td>
              <td style="width: 22%;">
                <ap-field [title]="''" [fieldId]="'prop-fmv-' + i" [styleClass]="'number-field'" [type]="'appkit-number'" [format]="''">
                  <input appkit-field onlyDigitsDecimal formControlName="fairMarketVal" [attr.aria-label]="'Fair market value ' + (i + 1)" />
                </ap-field>
              </td>
            </tr>
          }
        </ng-container>
        </tbody>
      </table>
      <div class="note-banner">
        <span class="Appkit4-icon icon-alert-outline"></span>&nbsp;
        <span class="one-point-four">Note: Share/change in ownership information is not required by the
          regulations and is optional information to be disclosed.
          If share/ownership information is not provided, then this paragraph will not display when
        saved.</span>
      </div>
      <div class="inline-paragraphs" formGroupName="shareChangeSec">
        <p class="one-point-four">
          <span>There were&nbsp;</span>
          <gtw-nullable-number-input
            [inlineBlock]="true"
            [id]="'380'"
            [minNum]="0"
            class="number-field"
            [(ngModel)]="sharesBeforeTransfer"
            [ngModelOptions]="{standalone: true}">
          </gtw-nullable-number-input>
          <span>&nbsp;and&nbsp;</span>
          <gtw-nullable-number-input
            [inlineBlock]="true"
            [id]="'381'"
            [minNum]="0"
            class="number-field"
            [(ngModel)]="sharesAfterTransfer"
            [ngModelOptions]="{standalone: true}">
          </gtw-nullable-number-input>
          <span>&nbsp;shares of capital stock of <span class="template-color-blue">{{!transferee ? '' :
          transferee.ENTITY}}</span> issued and outstanding immediately prior to and after the Transfer
        respectively.</span>
        <span class="template-color-blue">{{!transferor ? '' : transferor.ENTITY}}</span> owned
        <gtw-nullable-number-input
          [inlineBlock]="true"
          [id]="'382'"
          [minNum]="0"
          [maxNum]="100"
          class="number-field"
          [(ngModel)]="stockBeforeTransfer"
          [ngModelOptions]="{standalone: true}"
          [ngClass]="sharesBeforeTransfer && sharesAfterTransfer && sharesBeforeTransfer != sharesAfterTransfer && !stockBeforeTransfer? 'required-field' : ''">
        </gtw-nullable-number-input>
        <span>&nbsp;% and&nbsp;</span>
        <gtw-nullable-number-input
          [inlineBlock]="true"
          [id]="'383'"
          [minNum]="0"
          [maxNum]="100"
          class="number-field"
          [(ngModel)]="stockAfterTransfer"
          [ngModelOptions]="{standalone: true}"
          [ngClass]="sharesBeforeTransfer && sharesAfterTransfer && sharesBeforeTransfer != sharesAfterTransfer && !stockAfterTransfer? 'required-field' : ''">
        </gtw-nullable-number-input>
        <span>&nbsp;% of the</span>
        <ap-dropdown [list]="stockType[0]?.data || []" [selectType]="'single'" [showSearchbox]="true" [title]="'** select stock type **'" [inputAriaLabel]="'** select stock type **'"
          (onSelect)="selectStockType($event)" formControlName="stockType" [optionName]="'text'" [hideTitleOnInput]="true" [(ngModel)]="selectedStockTypeItem" [ngModelOptions]="{standalone: true}" class="a-dropdown inline-dropdown show-label required-field-dropdown select-dropdown">
          @for (item of stockType[0]?.data || []; track item) {
            <ap-dropdown-list-item #dropdownListItem [item]="item"
              [ariaLabel]="setAriaLabel(item, '** select stock type **')" [optionName]="'text'"
            (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
          }
        </ap-dropdown>
        <span>stock issued and outstanding of <span class="template-color-blue">{{!transferee ? '' :
        transferee.ENTITY}}</span> before and after the Transfer respectively.</span>
      </p>
      <p>
        <ap-checkbox class="sec304-checkbox" [styleClass]="'checkbox-font'"
          [ngModel]="isSection304Related === true"
          [ngModelOptions]="{standalone: true}"
          (onChange)="check304Section()">
          <span>Check here if this is a Section 351 transfer related to a Section 304 transaction.</span>
        </ap-checkbox>
      </p>
      @if (isSection304Related) {
        <div formGroupName="section304Details">
          <p class="inline-paragraphs one-point-two">
            The above described transfer is a Section 304(a) exchange that is treated as one to which Section
            351 applies. The following information
            further describes the Transfer: <span class="template-color-blue">{{!transferor ? '' :
          transferor.ENTITY}}</span> (a Significant Transferor), transferred&nbsp;
          <gtw-nullable-number-input
            [inlineBlock]="true"
            [id]="'384'"
            [minNum]="0"
            class="number-field required-field mr-3"
            [(ngModel)]="amtFromSigTransferor"
            [ngModelOptions]="{standalone: true}">
          </gtw-nullable-number-input>
          <ap-dropdown [list]="stockType304[0]?.data || []" [selectType]="'single'" [showSearchbox]="true" [title]="'** select stock type **'" [inputAriaLabel]="'** select stock type **'"
            (onSelect)="selectStockType304($event)" [optionName]="'text'" [hideTitleOnInput]="true" [(ngModel)]="selectedStockType304Item" [ngModelOptions]="{standalone: true}"
            class="inline-dropdown show-label required-field-dropdown">
            @for (item of stockType304[0]?.data || []; track $index) {
              <ap-dropdown-list-item #dropdownListItem [item]="item"
                [ariaLabel]="setAriaLabel(item, '** select stock type **')" [optionName]="'text'"
              (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
            }
          </ap-dropdown>
          shares in the capital of
        </p>
        <!-- <div class="a-form-error" *ngIf="isSection304Related && (this.form184.get('propertiesDetails')?.get('shareChangeSec')?.get('section304Details')?.get('amtFromSigTransferor')?.errors?.required)">
        Please specify Number Of Shares for 304 transactions
      </div> -->
      <!-- <print-error [control]="this.form184.get('propertiesDetails')?.get('shareChangeSec')?.get('section304Details')?.get('amtFromSigTransferor')?.errors.required"></print-error> -->
      <div>
        <div class="ap-form-field-my-wrapper">
          <dst-template-leid-selector
            [label]="'Please specify the LEID of the Target/Acquired Corporation:'" [labelId]="'3'"
            class="required-field entity-label" (onSelectedLEChanged)="onTransferLEIDChanged($event)">
          </dst-template-leid-selector>
          <!-- <div class="a-form-error error-leid" *ngIf="isSection304Related && (targetLEID === undefined)">
          Please specify Target/Acquired LEID for 304 transactions
        </div> -->
        <!-- <ap-form-field [label]="'Please specify the LEID of the Target/Acquired Corporation'" [id]="'385'" [type]="'input'"
        formControlName="targetLEID">
      </ap-form-field> -->
    </div>
    <p class="target-entity-details one-point-two inline-paragraphs">
      <span>Target/Acquired Corporation:</span><span class="template-color-blue">{{!targetLEID ? '' :
    targetLEID.ENTITY}}</span>, EIN: <span class="template-color-blue">{{!targetLEID ? '' :
  (targetLEID.EIN ? targetLEID.EIN : 'N/A')}}</span>, a <span class="template-color-blue">{{!targetLEID ? '' :
targetLEID.COUNTRYINC + (targetLEID | taxtype: targetLEID?.TAXTYPECODE: entityNameChangeOnDate)}}</span>, to <span
class="template-color-blue">{{!transferee ? '' : transferee.ENTITY}}</span>, (the Transferee
) in exchange for
<ap-dropdown [list]="section304ExchangeType[0]?.data || []" [selectType]="'single'" [title]="'Select'" [inputAriaLabel]="'Select'"
  (onSelect)="selectExchangeType($event)" [optionName]="'text'" [hideTitleOnInput]="true" [(ngModel)]="selectedExchangeTypeItem" [ngModelOptions]="{standalone: true}" class="required-field-dropdown">
  @for (item of section304ExchangeType[0]?.data || []; track $index) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setAriaLabel(item, 'Select')" [optionName]="'text'"
    (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
in the amount of
<span class="d-flex">
  <ap-field [fieldId]="'386'" [type]="'appkit-number'" [format]="''"
    [styleClass]="'number-field required-field'" [hideTitleOnInput]="true">
                    <input appkit-field onlyDigitsDecimal [(ngModel)]="amtInExchangeFor" [ngModelOptions]="{standalone: true}"  aria-label="386" />
  </ap-field>
  <ap-dropdown [list]="currencyOptions3[0]?.data || []" [selectType]="'single'" [showSearchbox]="true"
    (onSelect)="selectedCurrency3($event)" [optionName]="'text'" [hideTitleOnInput]="true" [(ngModel)]="selectedCurrencyItem3" [ngModelOptions]="{standalone: true}"
    style="margin-left: 10px;" [title]="'** Select Currency **'" [inputAriaLabel]="'** Select Currency **'"
    class="show-label currency-dropdown inline-dropdown required-field-dropdown">
    @for (item of currencyOptions3[0]?.data || []; track $index) {
      <ap-dropdown-list-item #dropdownListItem [item]="item"
        [ariaLabel]="setAriaLabel(item, '** Select Currency **')" [optionName]="'text'"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
    }
  </ap-dropdown>
</span>
<ap-field [fieldId]="'387'" [title]="''" [hideTitleOnInput]="true">
                    <textarea appkit-field [(ngModel)]="Para" [ngModelOptions]="{standalone: true}" aria-label="387"></textarea>
</ap-field>
</p>
</div>
</div>
}
</div>
</div>
</li>
</ol>
</div>
</li>
<li class="one-point-four">The date and control number of any private letter ruling(s) issued by IRS in connection
  with the section 351 exchange:
  <div id="step4" formGroupName="privateLetterRul">
    <app-date-picker-with-clear
      [minDate]="beginDate"
      [maxDate]="endDate"
      (dateChange)="dateChange($event, 4)"
      (datePickerClick)="onDPOpen()"
      (clearClick)="clearDate(4)"
      [(ngModel)]="liquidationDate4"
      [ngModelOptions]="{standalone: true}">
    </app-date-picker-with-clear>
    <ap-field [fieldId]="'401'" [title]="''" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="controlNum" [ngModelOptions]="{standalone: true}"  aria-label="401" />
    </ap-field>
  </div>
</li>
<li class="one-point-four">The following liabilities were assumed by <span
class="template-color-blue">{{!transferee ? '' : transferee.ENTITY}}</span> in the Transfer:
<div formGroupName="liabilitiesAssumed">
  <table class="table-layout">
    <tbody>
      <tr>
        <td colspan="2"></td>
        <td class="header-column"><span>Description</span></td>
        <td class="header-column"><span>Amount</span></td>
      </tr>
      <tr>
        <td colspan="3"></td>
        <td><span>(input liabilities as negative amounts)</span></td>
      </tr>
      <ng-container formArrayName="liabilityDetails">
        @for (l of liabilityDetails.controls; track l; let i = $index) {
          <tr [formGroup]="$any(l)">
            <td style="width: 3%;">
              @if (i > 0) {
                <ap-button [compact]="true" class="btn-plus-minus" [btnType]="'secondary'"
                  [icon]="'minus-outline'" [add]="true"
                  (onClick)="removeLiabilityDetailsAt(i)">
                </ap-button>
              }
            </td>
            <td style="width: 3%;">
              <ap-button [compact]="true" class="btn-plus-minus" [btnType]="'secondary'"
                [icon]="'plus-outline'" [add]="true"
                (onClick)="addLiabilityDetails()">
              </ap-button>
            </td>
            <td style="width: 70%;">
              <ap-field [title]="''" [fieldId]="'liab-desc-' + i" [hideTitleOnInput]="true">
                <input appkit-field formControlName="description" [attr.aria-label]="'Liability description ' + (i + 1)" />
              </ap-field>
            </td>
            <td>
              <ap-field [title]="''" [fieldId]="'liab-amt-' + i" [type]="'appkit-number'" [format]="''" [maxNum]="-1"
                [styleClass]="'number-field'" [hideTitleOnInput]="true">
                <input appkit-field onlyDigitsDecimal formControlName="amount" [attr.aria-label]="'Liability amount ' + (i + 1)" />
              </ap-field>
            </td>
          </tr>
        }
      </ng-container>
    </tbody>
  </table>
  <div class="supp-info-wrapper" formGroupName="suppInfo">
    <div><span class="Appkit4-icon icon-information-fill" ap-tooltip [tooltipContent]="template3" [direction]="'right'"
    [tooltipId]="'sec351-supplemental-info'" ariaDescribedby="sec351-supplemental-info"></span>Supplemental Information:</div>
    <ap-field [fieldId]="'550'" [title]="''" [hideTitleOnInput]="true">
                    <textarea appkit-field [(ngModel)]="info" [ngModelOptions]="{standalone: true}" aria-label="550"></textarea>
    </ap-field>
  </div>
  <dst-template-leid-selector class="one-point-two" [isBranchEntity]="true"
    [label]="'Please specify the LEID of the Branch Entity:'" [labelId]="'4'"
    (onSelectedLEChanged)="onBranchEntityChanged($event)" class="entity-label">
  </dst-template-leid-selector>
  <div class="entity-details one-point-two">
    <span>Branch Entity Name:</span><span class="template-color-blue">{{!branchEntity ? '' :
  branchEntity.ENTITY}}</span>
</div>
<!--          <div class="ap-form-field-my-wrapper" formGroupName="branchInfo">-->
<!--            <ap-form-field [label]="'Please specify the LEID of the Branch Entity'" [id]="'551'" [type]="'input'" formControlName="branchLEID">-->
<!--            </ap-form-field>-->
<!--          </div>-->
<!--          <div class="branch-entity-details">-->
<!--            <span>Branch Entity Name:</span><span></span>-->
<!--          </div>-->
<div class="leid-list one-point-four" style="margin-top: 15px;">
  <span>LEIDs: </span>
  <div>
    @if (transferee) {
      <span class="template-color-blue">{{ transferee.LEID }}</span>
      }@if (transferor) {
      <span>
      / </span>
      }@if (transferor) {
      <span class="template-color-blue">{{ transferor.LEID }}</span>
    }
  </div>
</div>
</div>
</li>
</ol>

</div>
</div>
<ng-template #template1>
  <div class="tooltip-inner ap-p-spacing-6 d-block a-min-width-340">
    <div class="a-h6 a-text-7d7 font-weight-normal text-left ap-mt-spacing-3">
      ***Please note, DST will automatically default to NONE in the boxes that specifically apply to loss importation
      property if §362(e)(1) and §334(b)(1)(B) DO NOT apply to the transaction. Please leave these fields blank if
      §362(e)(1) and §334(b)(1)(B) DO NOT apply to the transaction.***
    </div>
  </div>
</ng-template>
<ng-template #template2>
  <div class="tooltip-inner ap-p-spacing-6 d-block a-min-width-340">
    <div class="a-h6 a-text-7d7 font-weight-normal text-left ap-mt-spacing-3">
      Final regulations under §362(e)(1) and §334(b)(1)(B) apply to certain loss built-in loss transactions under §§
      351, 368 and 332 that would result in the importation of a loss into the U.S. Federal tax system. For the above
      mentioned in-bound nonrecognition transfers, the rules require identification of "importation property" on
      asset-by-asset basis using a hypothetical sale approach. Thus if the transferors gain or loss on the "sale" would
      not subject to federal tax but transferee/acquiring would be subject to federal tax on the sale of the transferred
      property, then the property is "importation property". If the aggregate basis of the importation property exceeds
      the aggregate FMV, then the transaction is a "loss importation transaction" and is subject to the anti-loss
      importation rules (i.e. basis is reduced to FMV). The final regulations generally apply to transactions occurring
      after March 27, 2016
      For further information, please refer to the Current Year Updates under Training in the DST.
    </div>
  </div>
</ng-template>
<ng-template #template3>
  <div class="tooltip-inner ap-p-spacing-6 d-block a-min-width-340">
    <div class="a-h6 a-text-7d7 font-weight-normal text-left ap-mt-spacing-3">
      Additional information to further describe the transaction may be added in text box
    </div>
  </div>
</ng-template>
